module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 float-box-title"
  }, [(_vm.registroVisualizacao) ? _c('h2', {
    staticClass: "pull-left"
  }, [(_vm.showReturnButton) ? _c('i', {
    staticClass: "fa fa-chevron-left action-icon",
    on: {
      "click": function($event) {
        _vm.ocultarRegistro()
      }
    }
  }) : _vm._e(), (!_vm.showReturnButton) ? _c('i', {
    staticClass: "mdi mdi-map-marker"
  }) : _vm._e(), _c('span', {
    attrs: {
      "title": _vm.registroVisualizacao.titulo
    }
  }, [_vm._v(_vm._s(_vm.registroVisualizacao.titulo || _vm.registroVisualizacao.nomeCamada))])]) : _vm._e()]), _c('div', {
    staticClass: "float-box-content default-padding col-md-12",
    attrs: {
      "id": "informacoesRegistro"
    }
  }, [(_vm.registroVisualizacao) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Camada:")]), _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.registroVisualizacao.nomeCamada))])]), _vm._l((_vm.registroVisualizacao.atributos), function(atr) {
    return (_vm.registroVisualizacao && _vm.registroVisualizacao.atributos && _vm.registroVisualizacao.atributos.length) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v(_vm._s(atr.nome) + ":")]), _c('p', {
      staticClass: "form-control-static"
    }, [_vm._v(_vm._s(atr.valor !== null ? atr.valor : '-'))])]) : _vm._e()
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.camada.possuiUrlMaisInformacoes),
      expression: "camada.possuiUrlMaisInformacoes"
    }],
    staticClass: "form-group"
  }, [_c('label', [_c('a', {
    attrs: {
      "href": _vm.urlMaisInformacoes,
      "target": "_blank"
    }
  }, [_vm._v("Mais informações")])])])], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-060d69c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VisualizacaoRegistroCamada.vue
// module id = 465
// module chunks = 1